import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/monitoramentoVisita';

class MonitoramentoVisitaService {
    cabecalho (monitoramentoVisita = {}) {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
        const usuario = (LoginService.currentUserValue && LoginService.currentUserValue.usuario) ? LoginService.currentUserValue.usuario : null;
        const isAcesso = monitoramentoVisita && monitoramentoVisita.pagina && monitoramentoVisita.pagina == 'acessoMonitoramento';
        return {
            ...monitoramentoVisita,
            idAcesso: (!isAcesso && localStorage.getItem('mvisit')) ? localStorage.getItem('mvisit') : "",
            idCliente: usuario ? usuario.idCliente : null,
            idUsuario: usuario ? usuario.idUsuario : null,
        };
    }

    async getUsuarioFiltro(filtro) {
        const pesquisa = {
            filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);
        try {
            const response = await axios.get(`${API_URL}/usuarioFiltro?${params.toString()}`, {headers: this.headers})
            return response.data.elements;
        } catch (error) {
            console.log(`Erro ao buscar usuários.`)
            throw error;
        }
    }

    async register(monitoramentoVisita) {
        await this.update();
        await this.save(monitoramentoVisita);
    }
    
    async save(monitoramentoVisita) {
        const isAcesso = monitoramentoVisita && monitoramentoVisita.pagina && monitoramentoVisita.pagina == 'acessoMonitoramento';
        try {
            await axios.post(API_URL, JSON.stringify(this.cabecalho(monitoramentoVisita)), {headers: this.headers})
            .then(
                response => {
                    if (isAcesso) {
                        localStorage.setItem('mvisit', response.data.id);
                    }
                }
            );
            
        } catch (error) {
            console.log(error);
        }
    }

    async update() {
        await axios.put(API_URL, JSON.stringify(this.cabecalho()),
        {headers: this.headers});
    }

    async updateAcesso() {
        await axios.put(`${API_URL}/acesso`, JSON.stringify(this.cabecalho()),
        {headers: this.headers});
    }

    async registerLogout() {
        await this.update();
        await this.updateAcesso();
    }

    async getAcessos(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/acessos?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getOnline(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return axios.get(`${API_URL}/online?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getVisitantes(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/visitantes?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getPaginas(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/paginas?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getAcessosChat(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/acessosChat?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }


    async getOnlineChat(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return axios.get(`${API_URL}/onlineChat?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getVisitantesChat(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/visitantesChat?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getMensagensRespondidasChat(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/mensagensRespondidasChat?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

    async getMensagensNaoRespondidasChat(filtro) {
        const pesquisa = {
            ...filtro,
            ...this.cabecalho(),
        }
        const params = new URLSearchParams(pesquisa);

        return await axios.get(`${API_URL}/mensagensNaoRespondidasChat?${params.toString()}`, 
        { headers: this.headers }).then(response => (this.data = response.data));
    }

}

export default new MonitoramentoVisitaService();